import { render, staticRenderFns } from "./createProtocolo.vue?vue&type=template&id=2caa215c&scoped=true&"
import script from "./createProtocolo.vue?vue&type=script&lang=js&"
export * from "./createProtocolo.vue?vue&type=script&lang=js&"
import style0 from "./createProtocolo.vue?vue&type=style&index=0&id=2caa215c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caa215c",
  null
  
)

export default component.exports